import axios from 'axios';
import auth0Client from '../auth0/authClient.js'

export default async function postApiData (endpoint, payload) {
    try {
        let authData = await auth0Client.getTokenSilently({ detailedResponse: true, ignoreCache: false, authorizeTimeoutInSeconds:30 }).catch(e => console.error(e));

        let options = {
            url: process.env.REACT_APP_RUUTS_API_URL + endpoint,
            method: 'POST',
            data: payload,
            timeout: 120000,
            headers: {
                Authorization: `Bearer ${authData.access_token}`
            }
        }
        let response = await axios.request(options);
        return response.data;
    } catch (error) {
        console.error(error);
        console.error(`Unable to post API data for ${endpoint} - ${error.message}`);
        throw new Error(`Unable to update data from ${endpoint}: ${error.message}`)
    }
}